import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";

const DISMISS_KEY = "ba30_install_dismissed";
const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (isStandalone() || localStorage.getItem(DISMISS_KEY)) return;
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS()) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, "1"); setShow(false); };
  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") setShow(false);
    setDeferred(null);
  };

  if (!show) return null;
  return (
    <div data-testid="install-prompt"
         className="fixed bottom-20 lg:bottom-6 left-4 right-4 lg:left-auto lg:right-6 lg:w-96 z-50 rounded-xl bg-foreground text-background shadow-2xl p-4 flex gap-3 items-start">
      <div className="w-10 h-10 shrink-0 rounded-lg bg-primary flex items-center justify-center">
        <Download size={18} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-head uppercase text-sm tracking-wider">Add BA30 to your phone</div>
        {deferred ? (
          <p className="text-xs text-background/70 mt-1">One tap. Opens full-screen like an app, no app store needed.</p>
        ) : (
          <p className="text-xs text-background/70 mt-1 flex flex-wrap items-center gap-1">
            Tap <Share size={12} className="inline" /> <b>Share</b> then <b>Add to Home Screen</b>.
          </p>
        )}
        {deferred && (
          <button onClick={install} data-testid="install-prompt-install-button"
                  className="mt-3 bg-primary text-white text-xs font-head uppercase tracking-widest px-4 py-2 rounded-full hover:opacity-90 transition-opacity">
            Install
          </button>
        )}
      </div>
      <button onClick={dismiss} aria-label="Dismiss" data-testid="install-prompt-dismiss-button"
              className="text-background/60 hover:text-background transition-colors">
        <X size={16} />
      </button>
    </div>
  );
}
